import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import "./MyUpcomingTasks.css";
import { Collapse } from "@mui/material";
import { useDoctorContext } from "../context/DoctorContext";

const MyUpcomingTasks = ({ docId }) => {
  const [expandedRows, setExpandedRows] = useState({});
  const navigate = useNavigate();
  const { vaccines, vaccineLoading, validateUpcommingTasks } = useDoctorContext();

  useEffect(() => {
    validateUpcommingTasks(docId);
  }, [navigate, docId]);

  const toggleExpand = (index, listType) => {
    setExpandedRows((prev) => ({
      [index]: {
        [listType]: !prev[index]?.[listType],
      },
    }));
  };

  return (
    <div className="my-upcoming-tasks">
      <Loader isLoading={vaccineLoading} />
      <div className="upcoming-vaccine-container">
        <h3>Upcoming Vaccinations</h3>
        {vaccines.length > 0 ? (
          <div className="upcomming-vaccine-list">
            <div className="upcoming-vaccine-grid vaccine-grid-header">
              <p>First Name</p>
              <p>Last Name</p>
              <p>Phone No.</p>
            </div>
            {vaccines.map(
              (vaccine, index) =>
                (vaccine.due_soon.length !== 0 ||
                  vaccine.not_taken.length !== 0) && (
                  <div key={index} className="upcoming-vaccine-items">
                    <div className="upcoming-vaccine-grid">
                      <p>{vaccine.first_name}</p>
                      <p>{vaccine.last_name}</p>
                      <p>{vaccine.parent.phone_number}</p>
                    </div>
                    <div className="vaccine-list-opner">
                      {vaccine?.due_soon.length > 0 && (
                        <button
                          className="upcomming-btn"
                          onClick={() => toggleExpand(index, "due_soon")}
                        >
                          {expandedRows[index]?.due_soon
                            ? "Hide Upcoming List"
                            : "View Upcoming List"}
                        </button>
                      )}

                      {vaccine?.not_taken.length > 0 && (
                        <button
                          className="missing-btn"
                          onClick={() => toggleExpand(index, "not_taken")}
                        >
                          {expandedRows[index]?.not_taken
                            ? "Hide Missing List"
                            : "View Missing List"}
                        </button>
                      )}
                    </div>

                    <Collapse in={expandedRows[index]?.due_soon}>
                      <table className="missing-table">
                        <thead>
                          <tr>
                            <td>Start Date</td>
                            <td>Vaccines</td>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const grouped = {};

                            // Step 1: Group by expected_date
                            vaccine.due_soon.forEach((item) => {
                              if (!grouped[item.expected_date]) {
                                grouped[item.expected_date] = [];
                              }
                              grouped[item.expected_date].push(item.vaccine);
                            });

                            // Step 2: Render grouped rows
                            return Object.entries(grouped).flatMap(
                              ([date, vaccines], i) =>
                                vaccines.map((vaccineName, index) => (
                                  <tr key={`${date}-${index}`}>
                                    {index === 0 && (
                                      <td
                                        rowSpan={vaccines.length}
                                        style={{ fontWeight: "bold" }}
                                      >
                                        {date}
                                      </td>
                                    )}
                                    <td>{vaccineName}</td>
                                  </tr>
                                ))
                            );
                          })()}
                        </tbody>
                      </table>
                    </Collapse>

                    <Collapse in={expandedRows[index]?.not_taken}>
                      <table className="missing-table">
                        <thead>
                          <tr>
                            <td>Dates</td>
                            <td>Vaccines</td>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const grouped = {};

                            // Step 1: Group by expected_date
                            vaccine.not_taken.forEach((item) => {
                              if (!grouped[item.expected_date]) {
                                grouped[item.expected_date] = [];
                              }
                              grouped[item.expected_date].push(item.vaccine);
                            });

                            // Step 2: Render grouped rows
                            return Object.entries(grouped).flatMap(
                              ([date, vaccines], i) =>
                                vaccines.map((vaccineName, index) => (
                                  <tr key={`${date}-${index}`}>
                                    {index === 0 && (
                                      <td
                                        rowSpan={vaccines.length}
                                        style={{ fontWeight: "bold" }}
                                      >
                                        {date}
                                      </td>
                                    )}
                                    <td>{vaccineName}</td>
                                  </tr>
                                ))
                            );
                          })()}
                        </tbody>
                      </table>
                    </Collapse>
                  </div>
                )
            )}
          </div>
        ) : (
          <p>No upcoming vaccinations found</p>
        )}
      </div>
    </div>
  );
};
export default MyUpcomingTasks;
